/**
 * Swiss mortgage rule constants ("Richtwerte"), validated in the Finavest W1 brief.
 *
 * These are *public, generic* affordability heuristics — explicitly NOT the
 * confidential bank matrix or partner acceptance criteria. Nothing here reveals
 * which bank does what; it is the same arithmetic any Swiss buyer can find.
 */
export const RULES = {
  /** Bank-standard maximum loan-to-value (Belehnung). */
  bankStandardLtv: 0.8,
  /** Minimum equity the client must actually own (hard equity, e.g. on account). */
  minOwnedEquity: 0.1,
  /** Boundary of the 1st mortgage; the part above is the amortising 2nd mortgage. */
  firstMortgageLtv: 0.65,
  /** Calculatory interest rate for affordability ("kalkulatorischer Zins"). */
  calcRate: 0.05,
  /** Maintenance / ancillary costs as a share of property value ("Nebenkosten"). */
  maintenance: 0.01,
  /** Years to amortise the 2nd mortgage. */
  amortYears: 15,
  /** Affordability ceiling: annual housing cost <= 1/3 of gross income ("Drittelregel"). */
  affordabilityMax: 1 / 3,
  /** Comfortable affordability margin -> "machbar" (green). */
  greenMax: 0.3,
} as const;

/**
 * Version tag for the rule set + verdict logic. Sent to the backend with every
 * lead so any result can be reproduced against the exact rules that produced it.
 * Bump whenever RULES or the verdict matrix changes.
 */
export const RULE_VERSION = 'ch-richtwerte-2026.1';

/** Small epsilon so float rounding never flips a verdict on a boundary. */
export const EPS = 1e-9;
